
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("hn4or", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $ca57fe111d1777c1$var$_jquery = $ca57fe111d1777c1$var$_interopRequireDefault((parcelRequire("eQYlV")));
function $ca57fe111d1777c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// ====================================================================================
// breadcrumbs.module
// ====================================================================================
var $ca57fe111d1777c1$var$updateBreadcrumbPosition = function updateBreadcrumbPosition() {
    var $breadcrumb = (0, $ca57fe111d1777c1$var$_jquery["default"])(".breadcrumb");
    if ($breadcrumb.length === 0) return;
    var container = $breadcrumb[0];
    var scrollLeft = container.scrollLeft, scrollWidth = container.scrollWidth, clientWidth = container.clientWidth;
    $breadcrumb.removeClass("scroll-start scroll-middle scroll-end");
    if (scrollLeft <= 0) $breadcrumb.addClass("scroll-start");
    else if (scrollLeft >= scrollWidth - clientWidth - 1) $breadcrumb.addClass("scroll-end");
    else $breadcrumb.addClass("scroll-middle");
};
var $ca57fe111d1777c1$var$initDragScroll = function initDragScroll() {
    var $breadcrumb = (0, $ca57fe111d1777c1$var$_jquery["default"])(".breadcrumb");
    if ($breadcrumb.length === 0) return;
    var isDragging = false;
    var startPosition = 0;
    var initialScrollLeft = 0;
    var hasMoved = false;
    var scrollTimeout;
    var dragThreshold = 5;
    var startDrag = function startDrag(pageX, scrollLeft) {
        isDragging = true;
        hasMoved = false;
        startPosition = pageX;
        initialScrollLeft = scrollLeft;
        $breadcrumb.addClass("dragging");
    };
    var endDrag = function endDrag() {
        isDragging = false;
        hasMoved = false;
        $breadcrumb.removeClass("dragging");
    };
    var handleMove = function handleMove(pageX) {
        var multiplier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        if (!isDragging) return false;
        var distance = Math.abs(startPosition - pageX);
        if (distance > dragThreshold) {
            hasMoved = true;
            var scrollDistance = (startPosition - pageX) * 1.5 * multiplier;
            $breadcrumb.scrollLeft(initialScrollLeft + scrollDistance);
            $ca57fe111d1777c1$var$updateBreadcrumbPosition();
            return true;
        }
        return false;
    };
    var isLinkElement = function isLinkElement(target) {
        var $target = (0, $ca57fe111d1777c1$var$_jquery["default"])(target);
        return $target.is("a") || $target.closest("a").length > 0;
    };
    // Mouse events
    $breadcrumb.on("mousedown", function(e) {
        if (!isLinkElement(e.target)) {
            startDrag(e.pageX - $breadcrumb.offset().left, $breadcrumb.scrollLeft());
            e.preventDefault();
        }
    }).on("mouseleave mouseup", endDrag).on("mousemove", function(e) {
        if (handleMove(e.pageX - $breadcrumb.offset().left)) e.preventDefault();
    });
    // Touch events
    $breadcrumb.on("touchstart", function(e) {
        if (!isLinkElement(e.target)) {
            var touch = e.originalEvent.touches[0];
            startDrag(touch.pageX, $breadcrumb.scrollLeft());
        }
    }).on("touchmove", function(e) {
        var touch = e.originalEvent.touches[0];
        if (touch && handleMove(touch.pageX)) e.preventDefault();
    }).on("touchend", endDrag);
    // Scroll events
    $breadcrumb.on("scroll", function() {
        $breadcrumb.addClass("scrolling");
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
            $breadcrumb.removeClass("scrolling");
        }, 150);
        $ca57fe111d1777c1$var$updateBreadcrumbPosition();
    });
    // Prevent link clicks during drag
    $breadcrumb.on("click", "a", function(e) {
        if ($breadcrumb.hasClass("dragging")) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    });
};
var $ca57fe111d1777c1$var$init = module.exports.init = function init() {
    (0, $ca57fe111d1777c1$var$_jquery["default"])("body").addClass("has-breadcrumb");
    var _initializeWhenReady = function initializeWhenReady() {
        if (document.readyState !== "complete") {
            setTimeout(_initializeWhenReady, 100);
            return;
        }
        $ca57fe111d1777c1$var$initDragScroll();
        $ca57fe111d1777c1$var$updateBreadcrumbPosition();
        (0, $ca57fe111d1777c1$var$_jquery["default"])(".breadcrumb-item").on("mouseenter touchend", $ca57fe111d1777c1$var$updateBreadcrumbPosition);
        (0, $ca57fe111d1777c1$var$_jquery["default"])(window).on("resize", $ca57fe111d1777c1$var$updateBreadcrumbPosition);
    };
    _initializeWhenReady();
};

});


//# sourceMappingURL=breadcrumb.module.3cbca53b.js.map
